<template>
    <sections>
        <section-cards
            v-if="jobs !== null"
            color="bg-zinc-100"
            heading="Jobs"
            :cards="
                jobs.map((job) => {
                    return {
                        route: job.job_route,
                        excerpt: excerpt(job),
                    };
                })
            "
        ></section-cards>
        <loading-spinner v-else></loading-spinner>
        <section-text
            v-if="jobs !== null"
            heading="Looking for a job?"
            content="<p>We have vacancies, contact us today.</p>"
            buttonText="Contact Us"
            buttonRoute="/contact"
            :textCentered="false"
        ></section-text>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'Jobs | ' + $config.public.siteName,
    description: 'Browse our available jobs.',
    index: true,
});

const {jobs} = storeToRefs(useJobsStore());

function excerpt(job) {
    let excerpt = '<div>';
    excerpt += '<div class="text-left text-xl font-medium tracking-tight sm:text-xl mb-4">' + job.job_title + '</div>';
    excerpt += job.job_location
        ? '<div class="text-left text-sm">' + job.job_location + '</div>'
        : '<div class="text-left text-sm">Location TBC</div>';
    excerpt += '</div>';
    return excerpt;
}
</script>
